import React from 'react'
import {LoginTypeSwitch, LoginBtn} from './signCmp'
import {Link, withRouter} from "react-router-dom";
import {SignInputPhone, SignInputPassword, SignInputVCode, SignNewInputPhone} from "./signInputs";
import {Checkbox} from "antd";
import Util from "../public/utils";
import CorpApi from "../public/corp_api";
import {Path} from "../public/path";
import {CaptchaType} from "../public/mtype";
import Message from "../cmpts/ant/Message";
import PubSub from "pubsub-js";
import Store from "../store";

const LoginType = {
    wx: 'wx',
    account: 'account'
};

const AccountType = {
    pwd: 'pwd',//密码
    code: 'code'//验证码
};

const DefaultPwdError = {
    phone: {
        error: false,
        errorDes: ''
    },
    password: {
        error: false,
        errorDes: ''
    }
};

const DefaultCodeError = {
    phone: {
        error: false,
        errorDes: ''
    },
    vcode: {
        error: false,
        errorDes: ''
    }
};

const ZIKUNUSER = 'zikunuser';

class SignIn extends React.Component {

    constructor(props) {
        super(props);
        this.getLoginTypeFromUrl = this.getLoginTypeFromUrl.bind(this);
        this.accountLogin = this.accountLogin.bind(this);
        this.phoneNoNotExists = this.phoneNoNotExists.bind(this);
        this.rememberPwd = this.rememberPwd.bind(this);
        this.loginOver = this.loginOver.bind(this);
        this.beginLogin = this.beginLogin.bind(this);
        this.resetError = this.resetError.bind(this);
        this.state = {
            loginType: '',
            accountType: AccountType.pwd,
            pwdError: JSON.parse(JSON.stringify(DefaultPwdError)),
            codeError: JSON.parse(JSON.stringify(DefaultCodeError)),
            rememberPwd: true,
            zikunuser: this.getZiKunUser(),
            isLogin: false,
            target: null,
        };
        this.PwdRef = {};
        this.CodeRef = {};
    }

    componentDidMount() {
        this.getLoginTypeFromUrl();
        let target = Util.getUrlArg("target");
        if (target) {
            this.setState({target: target});
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.getLoginTypeFromUrl();
    }

    getZiKunUser() {
        let zikunuser = {
            phoneNo: '',
            password: ''
        };
        try {
            let userInfo = window.localStorage.getItem(ZIKUNUSER);
            if (userInfo) {
                userInfo = JSON.parse(userInfo);
                if (userInfo) {
                    zikunuser.phoneNo = userInfo.phoneNo;
                    zikunuser.password = userInfo.password;
                }
            }
        } catch (e) {

        }
        return zikunuser;
    }

    getLoginTypeFromUrl() {
        let hash = this.props.history.location.hash;
        if (hash.startsWith('#')) {
            hash = hash.substring(1);
            if (LoginType.wx == hash || LoginType.account == hash) {
                this.setState({loginType: hash});
                return;
            }
        }
        window.location.hash = LoginType.account;
    }

    loginTypeChange() {
        let loginType = this.state.loginType;
        if (loginType == LoginType.wx) {
            loginType = LoginType.account;
        } else if (loginType == LoginType.account) {
            loginType = LoginType.wx;
        }
        window.location.hash = loginType;
    }

    login() {
        if (!this.state.isLogin) {
            this.resetError();
            let accountType = this.state.accountType;
            let source = Util.getUrlArg("source");
            if (accountType == AccountType.pwd) {
                let phone = this.PwdRef.phone;
                let password = this.PwdRef.password;
                if (phone.check() && password.check()) {
                    let phoneVal = phone.getValue();
                    let passwrodVal = password.getValue();
                    let rememberPwd = this.rememberPwd.bind(this, phoneVal, passwrodVal);
                    let params = {
                        phoneNo: phoneVal,
                        password: Util.hashPwd(passwrodVal),
                        type: 0,//密码登录
                        login3Days: 0,
                        source: source
                    };
                    //账号密码登录
                    this.accountLogin(params, rememberPwd);
                }
            } else if (accountType == AccountType.code) {
                let phone = this.CodeRef.phone;
                let vcode = this.CodeRef.vcode;
                if (phone.check() && vcode.check()) {
                    let phoneVal = phone.getValue();
                    let vcodeVal = vcode.getValue();
                    let params = {
                        phoneNo: phoneVal,
                        captcha: vcodeVal,
                        type: 1,//验证码登录
                        login3Days: 0,
                        source: source
                    };
                    this.accountLogin(params);
                }
            }
        }
    }

    beginLogin() {
        this.setState({
            isLogin: true
        })
    }

    loginOver() {
        this.setState({
            isLogin: false
        })
    }

    //账号登录
    accountLogin(params, success) {
        this.beginLogin();
        let loginSuccess = this.loginSuccess.bind(this);
        let type = params.type;
        let loginError;
        if (type == 0) {
            loginError = this.pwdLoginError.bind(this);
        } else if (type == 1) {
            loginError = this.codeLoginError.bind(this);
        }
        let loginOver = this.loginOver;
        CorpApi.userLogin(params, function (res) {
            if (success) {
                success();
            }
            if (params.password != 'f3d673135a08bbde8132ebb0bc261630') {
                //过滤掉自己账号人员登录
                res.report = 1
            }
            loginSuccess(res);
        }, function (error) {
            if (loginError) {
                loginError();
            }
            loginOver();
        }, function () {
            loginOver();
        });
    }

    rememberPwd(phoneNo, password) {
        let rememberPwd = this.state.rememberPwd;
        if (rememberPwd) {
            //记住密码
            let zikunuser = {
                phoneNo: phoneNo,
                password: password
            };
            window.localStorage.setItem(ZIKUNUSER, JSON.stringify(zikunuser));
        } else {
            window.localStorage.removeItem(ZIKUNUSER);
        }
    }

    //登录成功，跳转到首页
    loginSuccess(respMsg) {
        CorpApi.getUserOpenId((data) => {
            this.props.subAction(data)
            Store.setUserInfo(data);
        })
        this.props.history.push(Path.getDashboard());
        this.loginOver();
        if (respMsg.report == 1) {
            let userID = respMsg.userID;
            window.albatrossInstance.login(userID, "zikun");
        }
    }

    pwdLoginError() {
        let pwdError = this.state.pwdError;
        pwdError.password.error = true;
        pwdError.password.errorDes = '账号或密码错误';
        this.setState({
            pwdError: pwdError
        });
    }

    codeLoginError() {
        let codeError = this.state.codeError;
        codeError.vcode.error = true;
        codeError.vcode.errorDes = '账号或验证码错误';
        this.setState({
            codeError: codeError
        });
    }

    resetError() {
        this.setState({
            pwdError: JSON.parse(JSON.stringify(DefaultPwdError)),
            codeError: JSON.parse(JSON.stringify(DefaultCodeError))
        });
        this.setState({
            codeError: JSON.parse(JSON.stringify(DefaultCodeError))
        });
    }

    accountTypeChange(e) {
        let type = e.target.getAttribute('data-target');
        if (type == AccountType.code || type == AccountType.pwd) {
            this.setState({
                accountType: type
            })
        }
        this.resetError();
    }

    rememberPwdChange(e) {
        this.setState({
            rememberPwd: e.target.checked
        })
    }

    sendCode(callback) {
        let phone = this.CodeRef.phone;
        if (phone.check()) {
            let params = {
                phoneNo: phone.getValue(),
                type: CaptchaType.UserLogin
            };
            let phoneNoNotExists = this.phoneNoNotExists;
            //调用接口发送验证码
            CorpApi.userCaptcha(params, function () {
                if (callback) {
                    callback();
                }
            }, function (resp) {
                let respCode = resp.respCode;
                if (respCode == 40027) {
                    //验证码请求太频繁
                    Message.error("验证码发送太频繁，请稍后再试");
                } else if (respCode == 40026) {
                    phoneNoNotExists();
                } else {
                    Message.error("验证码发送太频繁，请稍后再试");
                }
            });
        }
    }

    phoneNoNotExists() {
        let codeError = this.state.codeError;
        codeError.phone.error = true;
        codeError.phone.errorDes = '手机号不存在';
        this.setState({
            codeError: codeError
        })
    }


    render() {
        return (
            <div className='login-wraper'>
                {/*<LoginTypeSwitch type={this.state.loginType} typeChange={this.loginTypeChange.bind(this)}/>*/}
                {
                    this.state.loginType == LoginType.account ? <div className='account-login'>
                            <div className='account-type' onClick={this.accountTypeChange.bind(this)}>
                                <p data-target={AccountType.pwd}
                                   className={this.state.accountType == AccountType.pwd ? 'account-type-item account-type-item-active' : 'account-type-item'}>密码登录</p>
                                <p data-target={AccountType.code}
                                   className={this.state.accountType == AccountType.code ? 'account-type-item account-type-item-active' : 'account-type-item'}>验证码登录</p>
                            </div>
                            {
                                this.state.accountType == AccountType.pwd ? <div className='account-login-wraper'>
                                    <div className='signinput-wraper'>
                                        <SignNewInputPhone key='login-pwd-phone' ref={r => this.PwdRef.phone = r}
                                                           value={this.state.zikunuser.phoneNo}
                                                           error={this.state.pwdError.phone.error}
                                                           errorDes={this.state.pwdError.phone.errorDes}
                                                           onEnter={this.login.bind(this)}/>
                                        <SignInputPassword key='login-pwd-password' ref={r => this.PwdRef.password = r}
                                                           value={this.state.zikunuser.password}
                                                           error={this.state.pwdError.password.error}
                                                           errorDes={this.state.pwdError.password.errorDes}
                                                           onEnter={this.login.bind(this)}/>
                                    </div>
                                    <div className='account-opt'>
                                        <Checkbox defaultChecked={this.state.rememberPwd}
                                                  onChange={this.rememberPwdChange.bind(this)}>记住密码</Checkbox>
                                        <Link className='findpass' to={Path.getUserFindPass(this.state.target)}>忘记密码</Link>
                                    </div>
                                </div> : <div className='account-login-wraper'>
                                    <div className='signinput-wraper'>
                                        <SignInputPhone key='login-code-phone' ref={r => this.CodeRef.phone = r}
                                                        error={this.state.codeError.phone.error}
                                                        errorDes={this.state.codeError.phone.errorDes}
                                                        onEnter={this.login.bind(this)}/>
                                        <SignInputVCode keu='login-code-vcode' ref={r => this.CodeRef.vcode = r}
                                                        onEnter={this.login.bind(this)}
                                                        error={this.state.codeError.vcode.error}
                                                        errorDes={this.state.codeError.vcode.errorDes}
                                                        sendCode={this.sendCode.bind(this)}/>
                                    </div>
                                    <div className='account-opt'>
                                        <span></span>
                                    </div>
                                </div>
                            }
                            <LoginBtn btnText="登录" btnOnClick={this.login.bind(this)}
                                      loginSwitch={<span>还没账号？<Link to={Path.getUserRegister(this.state.target)}>立即注册</Link></span>}
                                      loading={this.state.isLogin}/>
                        </div>
                        : <div className='wx-login'>

                        </div>
                }
            </div>
        )
    }
}

export default withRouter(SignIn)